import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Banner from "components/SectionHero/Banner";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import $ from 'jquery';
import { useLocation } from 'react-router-dom';

const TermsOfUsePage: React.FC = () => {
    
    const location = useLocation();

    const moveTerms = (event:any) => {
        var hash:any = $(event.target).attr('href');
        var target:any = $(hash);
        $('html, body').animate({
            scrollTop: target.offset().top - 85
        }, 1000);
    }

    useEffect(() => {
        // Function to scroll to the section based on hash
        const scrollToHash = () => {
          const hash = window.location.hash; // Get the hash from the URL
          if (hash) {
            var target:any = $(hash);
            $('html, body').animate({
                scrollTop: target.offset().top - 85
            }, 1000);
          }
        };
    
        // Call the scroll function when the component mounts or when location changes
        scrollToHash();
      }, [location]);

    const renderSidebar = () => {
        return (
            <div className=" w-full flex flex-col items-start text-left sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                {/* ---- */}
                <div className="space-y-3 text-center flex flex-col items-start">
                    <h2 className="text-3xl font-semibold">Table of Contents</h2>
                </div>

                {/* ---- */}
                <div className="grid grid-cols-1 lg:grid-cols-1 gap-2 text-sm text-neutral-700 dark:text-neutral-300 ">
                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Introduction">Introduction</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Definitions">Definitions</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Privacy">Privacy Policy</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Services">Services</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Orders">Loading and Unloading</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Payment">Collections and Deliveries</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Delivery-and-Collection"> Returns and Held Items</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Packaging-and-Labeling">Surcharges</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Liability">Insurance & Claims Terms & Conditions</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Cancellation-and-Refunds">Cancellation & Rescheduling</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Working-Hours">Working Hours</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Governing-Law">Governing Law</a></span>
                    </div>

                    <div className="flex items-center space-x-3">
                        <i className="las la-check-circle text-2xl"></i>
                        <span><a onClick={moveTerms} href="#Contact-Information">Contact Information</a></span>
                    </div>
                </div>

            </div>
        );
    };

    const renderSection1 = () => {
        return (
            <>
                <style>
                {`
                    .terms_n p {
                        font-size: 14px;
                        color: #374151;
                        padding-bottom: 8px;
                        line-height: 20px;
                    }
                    .terms_n strong {
                        font-size: 18px;
                        padding: 10px 0px !important;
                        display: block;
                    }
                `}
                </style>
                <div className="listingSection__wrap">
                    <div className="terms_n">
                        <p id="Introduction">
                            <strong>
                                <span>01 Introduction</span>
                            </strong>
                        </p>
                        <ul>
                            <li>These Terms and Conditions govern the use of our pallet delivery services. By using our services, you agree to be bound by these terms. Please read them carefully.</li>
                        </ul>
                
            
                        <p id="Definitions">
                            <strong>
                                <span>02 Definitions</span>
                            </strong>
                        </p>
                        <p>
                            <span>Company: Refers to Pallet Booking, a division of Goodwill Logistics Limited, registered number 10732900.</span>
                        </p>
                        <p>
                            <span>Customer: Any individual or business using our pallet delivery services.</span>
                        </p>
                        <div>
                            <ul>
                                <li>
                                    <strong>
                                        <span>Goods: Items being transported on pallets.</span>
                                    </strong>
                                </li>
                                <li>
                                    <strong>
                                        <span>Pallet: A flat transport structure that supports goods in a stable manner.</span>
                                    </strong>
                                </li>
                            </ul>
                        </div>

                        <p id="Privacy">
                            <strong>
                                <span>03 Privacy Policy</span>
                            </strong>
                        </p>
                        <p>
                            <span>We are committed to protecting your privacy. This policy outlines how we collect, use, and protect your personal information.</span>
                        </p>
                        <p>
                            <span> Data Collection: We collect personal data such as your name, address, contact details, and payment information when you place an order or contact us.</span>
                        </p>
                        <p>
                            <span>Use of Data: Your personal data is used to process orders, manage your account, and communicate with you regarding our services.</span>
                        </p>
                        <p>
                            <span>Data Sharing: We do not share your personal data with third parties, except as necessary to provide our services or as required by law.</span>
                        </p>
                        <p>Your Rights: You have the right to access, correct, or delete your personal data. You can contact us at sales@palletbooking.co.uk to exercise these rights.</p>
                        <p>
                            <span> Cookies: Our website uses cookies to enhance your browsing experience. You can disable cookies through your browser settings, but this may affect the functionality of our website.</span>
                        </p>
            
                        <p id="Services">
                            <strong>
                                <span>04 Services</span>
                            </strong>
                        </p>
                        <p>
                            <span>We provide pallet delivery services within the UK, including collection, transportation, and delivery of goods.</span>
                        </p>
            
                        <p id="Orders">
                            <strong>
                                <span>05 Loading and Unloading</span>
                            </strong>
                        </p>
                        <p>
                            <span>
                                We will collect products that are on a pallet and properly wrapped, unless you have booked a pallet and wrap service.
                                {/* Where collection or delivery takes place at your premises, PalletBooking is not responsible for providing any additional staff or equipment for loading or unloading other than the driver. */}
                            </span>
                        </p>
                        <p>
                            <span>If your consignment (or part of it) requires specialist loading/unloading equipment, you must ensure
                            such equipment is available at the collection and/or delivery address.</span>
                        </p>

                        
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                <span>We have no liability for any loss or damage during loading/unloading in such circumstances,
                                even if caused by our negligence; and</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>You will fully indemnify us against any claims arising from that loading/unloading.</span>
                                </p>
                            </li>
                        </ul>

                        <p>
                            Used engines will only be accepted if they are contained within a suitable crate, stillage, or purpose-built transport frame.
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                <span>Engines placed directly on pallets are no longer accepted under any circumstances.</span>
                                </p>
                            </li>
                        </ul>
                        
                        <p>
                            Requirements for Engine Transport The crate, stillage, or frame must:
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                <span>Be strong enough for the engine's weight and size.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Prevent movement during transit.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Be suitable for forklift handling.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Protect both the engine and other freight from damage.</span>
                                </p>
                            </li>
                        </ul>

                        <p>
                            Engine Preparation Requirements
                        </p>
                        <p>
                            Before shipping:
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                <span>Drain all oil, fuel, and coolant.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Clean off excess grease, oil, and debris.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Seal all openings to prevent dirt and water ingress.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Protect vulnerable components such as sensors, wiring, pulleys, and turbo inlets.</span>
                                </p>
                            </li>
                        </ul>

                        <p>
                            Securing the Engine
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                <span>The engine must be firmly secured inside the crate or stillage using appropriate restraints, bolts, brackets, banding, or similar methods.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                <span>Leak containment measures such as absorbent pads or drip trays should be included.</span>
                                </p>
                            </li>
                        </ul>

                        <p>
                            The following are not allowed:
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p><span>Engines on pallets without a crate/stillage/frame.</span></p>
                            </li>
                            <li>
                                <p><span>Using rope, tape, stretch wrap, or shrink wrap as the primary securing method.</span></p>
                            </li>
                        </ul>

                        <p id="Payment">
                            <strong>
                                <span>06 Collections and Deliveries</span>
                            </strong>
                        </p>
                        <p>
                            <span>Collection and delivery dates/times provided are estimates only and are not guaranteed. Delays may occur due to circumstances outside our control. No refund (full or partial) will be issued for such delays.</span>
                        </p>
                        <p>
                            <span>If a collection cannot be completed because:</span>
                        </p>
                        <ul className="list-disc pl-10 ">
                            <li><p>No one is present,</p></li>
                            <li><p>The address is incorrect/incomplete,</p></li>
                            <li><p>The goods are not ready/suitable for transport, or</p></li>
                            <li><p>Any other reason preventing collection,</p></li>
                        </ul>
                        <p>
                            <span>We commit to at least one delivery attempt. If delivery is unsuccessful, we may attempt re-delivery at
                            additional cost which should be paid prior the attempt.</span>
                        </p>

                        <p>
                            <span>Some services allow parcels/pallets to be left in a location the driver considers safe (e.g., porch,
                            outbuilding). If left in such a location, no claim for loss/damage will be accepted.</span>
                        </p>
                        <p>
                            <span>If your consignment is held after a failed delivery, it is your responsibility to arrange re-delivery or
                            collection. Unclaimed consignments may be returned, and additional charges may apply.</span>
                        </p>
                        <p>
                            <span>Next-day or timed deliveries are not guaranteed for distances over 200 miles. No refund is due if the
                            service takes longer.</span>
                        </p>
                        <p>
                            <span>If a delivery or collection has failed, it is the Customer's responsibility to contact the Company to
                            arrange another delivery or collection. In the event of an attempted collection, the Customer will be
                            subject to a £20+VAT per pallet fee. This sum will need to be paid to the Company prior to any recollection. For an arranged re-delivery, the Customer will be subject to a £25+VAT per pallet. This
                            sum will need to be paid to the Company prior to any re-collection or re-delivery.</span>
                        </p>


                        
                        <p id="Delivery-and-Collection">
                            <strong>
                                <span>07 Returns and Held Items</span>
                            </strong>
                        </p>

                        <p>
                            <span>After a failed delivery, your item will be returned to the local depot. If you do not arrange re-delivery
                            within 5 working days, it may be sent to PalletBooking’s central facility at your cost.</span>
                        </p>
                        <br />

                        <p>
                            <span>Items held at our facility will be stored for a maximum of 10 working days. After this time, they may
                            be disposed of. Immediate disposal may occur if the item:</span>
                        </p>
                        <p>
                            <span>(a) Presents a health or safety risk (e.g., broken glass, hazardous material).</span>
                        </p>
                        <p>
                            <span>(b) Is damaged or unsuitable for transport and not collected within 48 hours after notice.</span>
                        </p>
                        <p>
                            <span>(c) Contains flammable/hazardous substances.</span>
                        </p>
                        <p>
                            <span>(d) Is leaking liquid of any kind.</span>
                        </p>
                        <br />

                        <p>
                            <span>We will attempt to contact you by the details provided on your booking. We are not liable if your
                            details are incorrect and the item is disposed of as per these terms.</span>
                        </p>

                        <br />
                        <p>
                            <span>Items may also be held if:</span>
                        </p>
                        <p>
                            <span>(a) They are heavier/larger than declared (extra fees apply).</span>
                        </p>
                        <p>
                            <span>(b) Incorrect booking details require return to sender (no refund).</span>
                        </p>
                        <p>
                            <span>(c) Packaging is inadequate (repackaging fees apply before forwarding).</span>
                        </p>
                        <p>
                            <span>(d) They contain prohibited goods (these will be returned or disposed of at your expense).</span>
                        </p>
                        
                        <p id="Packaging-and-Labeling">
                            <strong>
                                <span>08 Surcharges</span>
                            </strong>
                        </p>
                        
                        <p>
                            <span>Providing incorrect shipment details (weight, size, value, quantity) may result in additional charges.</span>
                        </p>
                        <p>
                            <span>If you send goods that are not accepted under the chosen service (e.g., prohibited shapes/items),
                            extra handling fees will apply.</span>
                        </p>
                        <p>
                            <span>Insufficient packaging will incur a repackaging surcharge.</span>
                        </p>
                        <p>
                            <span>Changing address details after the item is in transit may incur charges up to the full booking cost.</span>
                        </p>
                        <p>
                            <span>Changing the collection address on the day of collection will result in a surcharge.</span>
                        </p>
                        <p>
                            <span>All surcharges must be paid within 7 working days of request. If unpaid, we may deduct the amount
                            from stored payment or hold the pallets.</span>
                        </p>


                        <p id="Liability">
                            <strong>
                                <span>09 Insurance & Claims Terms & Conditions
                                </span>
                            </strong>
                        </p>
                        
                        <p>
                            <span>These Insurance & Claims Terms apply to all consignments booked through <b>PalletBooking</b> (“the
                            Company”). By placing a booking, you accept and agree to these terms.</span>
                        </p>
                        
                        <br />
                        <p>
                            <span><b>Insurance Cover</b></span>
                        </p>
                        <p>
                            <span>All consignments are automatically covered for <b>£5.00 per kilogram</b> of the gross weight of the
                            goods, <b>subject to a minimum claim value of £55.00</b> per consignment.</span>
                        </p>
                        <p>
                            <span>This cover applies only to physical loss of or damage to goods during transit and does not cover
                            consequential loss, delay, or deterioration caused by inherent vice or inadequate packaging.</span>
                        </p>
                        <p>
                            <span>Additional cover is not available unless agreed in writing prior to booking.</span>
                        </p>
                        <br />
                        <p>
                            <span><b>Claim Process</b></span>
                        </p>
                        <p>
                            <span>All claims must be submitted in writing within 7 calendar days of delivery (or expected delivery in
                            the case of loss).</span>
                        </p>
                        <p>
                            <span>Claims must include:</span>
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                    <span>Booking reference number.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Proof of delivery (if applicable).</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Evidence of weight of goods.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Photographic evidence of damage (if applicable).</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Commercial invoice or proof of value.</span>
                                </p>
                            </li>
                        </ul>
                        
                        <p>
                            <span>Failure to provide the above documentation within the stated period may result in the claim being
                            rejected.</span>
                        </p>

                        <p>
                            <span><b>Claim Handling</b></span>
                        </p>
                        <p>
                            <span>All claims are handled by our appointed third-party insurance intermediary, <b>One Broker</b>.</span>
                        </p>
                        <p>
                            <span>Submission of a claim does not guarantee acceptance or payment; all claims are <b>subject
                            entirely to One Broker’s review, approval, and policy terms.</b></span>
                        </p>
                        <p>
                            <span>The claim review process may take <b>up to 6 weeks</b> from the date of complete submission.</span>
                        </p>
                        <p>
                            <span>Decisions made by One Broker are final and binding on the Company.</span>
                        </p>
                        

                        <p>
                            <span><b>Exclusions</b></span>
                        </p>
                        <p>
                            <span>The following are <b>not covered:</b></span>
                        </p>
                        <ul className="list-disc pl-10">
                            <li>
                                <p>
                                    <span>Consequential or indirect loss (including loss of profits).</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Damage caused by inadequate packaging or incorrect labelling.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Perishable, prohibited, or restricted goods.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Loss or damage due to delays outside the Company’s control.</span>
                                </p>
                            </li>
                            <li>
                                <p>
                                    <span>Any item excluded under One Broker’s policy terms and conditions.</span>
                                </p>
                            </li>
                        </ul>
                        
                        <p>
                            <span><b>Liability Limitations</b></span>
                        </p>
                        <p>
                            <span>The Company’s maximum liability is limited to <b>£5.00 per kilogram of gross weight</b>, subject to a
                            <b>minimum total claim value of £55.00 per consignment.</b></span>
                        </p>
                        <p>
                            <span>Where the value of goods is less than the applicable limit, compensation will be based on the
                            actual value of the goods, supported by valid proof of value.</span>
                        </p>



                        <p id="Cancellation-and-Refunds">
                            <strong>
                                <span>10 Cancellation and Rescheduling</span>
                            </strong>
                        </p>
                        <p>
                            <span><b>Cancellation</b></span>
                        </p>
                        <p>
                            <span>Customers may cancel a booking by providing at least <b>48 hours’ notice</b> prior to the scheduled
                            collection date and time to our given official email address sales@palletbooking.co.uk.</span>
                        </p>
                        <p>
                            <span>Cancellations made with the required notice will receive a <b>full refund</b> of the booking fee.</span>
                        </p>
                        <p>
                            <span>Cancellations made <b>less than 48 hours</b> before the scheduled collection date and time will be
                            charged <b>100% of the booking fee</b>, and no refund will be issued.</span>
                        </p>
                        <p>
                            <span><b>Rescheduling</b></span>
                        </p>
                        <p>
                            <span>Customers may request to reschedule a collection or delivery date by providing at least <b>48 hours’ notice</b>
                            notice before the scheduled time.</span>
                        </p>
                        <p>
                            <span>Rescheduling requests made within the 48-hour notice period may incur additional charges at the
                            Company’s prevailing rates.</span>
                        </p>
                        <p>
                            <span>All rescheduled dates are subject to vehicle and driver availability, and the Company cannot
                            guarantee specific time slots.</span>
                        </p>
                        <p>
                            <span><b>Notice Period</b></span>
                        </p>
                        <p>
                            <span>The notice period is calculated from the scheduled collection date and time, counting backwards <b>48 hours</b>.</span>
                        </p>
                        <p>
                            <span>Notice must be given in writing via the Company’s official email address.</span>
                        </p>



                        <p id="Working-Hours">
                            <strong>
                                <span>11 Working Hours</span>
                            </strong>
                        </p>
                        <p>
                            <span>Our office operating hours are:</span>
                        </p>
                        <p>
                            <span>Monday to Friday – 09:00 to 17:00 (UK time)</span>
                        </p>
                        <p>
                            <span>Closed on Saturdays, Sundays, and Public Holidays</span>
                        </p>
                        <p>
                            <span>Any emails, enquiries, or support requests received outside of working hours will be
                            acknowledged on the next working day and actioned thereafter.</span>
                        </p>
                        <p>
                            <span>Operational deadlines (including booking amendments, cancellations, and rescheduling
                            requests) are based on working hours only. Requests sent outside of working hours will be
                            acknowledged on the next working day and actioned thereafter.</span>
                        </p>


                        <p id="Governing-Law">
                            <strong>
                                <span>12 Governing Law</span>
                            </strong>
                        </p>
                        <p>
                            <span>These terms are governed by the laws of England and Wales. Any disputes will be resolved in the courts of England and Wales</span>
                        </p>
            
                        <p id="Contact-Information">
                            <strong>
                                <span>13 Contact Information</span>
                            </strong>
                        </p>
                        <p>
                            <span>For any queries or complaints, please contact our customer service team at:</span>
                        </p>
                        <p>
                            <span>Address: Unit D, Knaves Beech Industrial Estate, Knaves Beech Way, Loudwater, High Wycombe, England, HP10 9QY.</span>
                        </p>
                        <p>Website: <a href="https://www.palletbooking.co.uk" target="_blank">www.palletbooking.co.uk</a></p>
                        <p>Contact No: <a href="tel:+441753525959">+44 (0) 1753525959</a></p>
                        <p>Email: <a href="mailto:sales@palletbooking.co.uk">sales@palletbooking.co.uk</a></p>

                    </div>
                </div>
            </>
        );
    };

    return (
        <div className={`nc-PayPage`} data-nc-id="PayPage">
            <div
                className={`nc-PageAbout overflow-hidden relative`}
                data-nc-id="CheckOut"
            >
                <Helmet>
                    <title>Terms And Condition | PalletBooking</title>

                    <meta property="og:title" content="Pallet Booking Terms and Conditions" />
                    <meta property="og:description" content="Review Pallet Booking's terms and conditions to understand the guidelines and policies governing our services." />
                    <meta property="og:image" content="/images/logo-site.png" />
                    <meta property="og:url" content="/terms-of-use" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="PalletBooking" />
                    <meta property="og:locale" content="en_US" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content="Pallet Booking Terms and Conditions" />
                    <meta name="twitter:description" content="Learn about our terms and conditions to ensure you fully understand our pallet delivery services and usage policies." />
                    <meta name="twitter:image" content="/images/logo-site.png" />

                </Helmet>

                {/* ======== BG GLASS ======== */}
                {/* <BgGlassmorphism /> */}

                <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
                    <Banner
                        textClass="text-center"
                        heading="Terms And Condition"
                        btnText=""
                        subHeading="By using or accessing this Website, placing an order and/or registering as a member of the Website the Customer agrees to be bound by the Conditions set out below. Should the Customer have any queries in relation to the Conditions, the Customer should contact the Company's customer service department via Live Chat during business hours."
                    />
                </div>
            </div>

            <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
                </div>
                <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
                    {renderSection1()}
                </div>
            </main>

            <div className="container py-6">
                {/* <SectionSubscribe2 className="" /> */}
            </div>
        </div>
    );
};

export default TermsOfUsePage;
